import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import uk from './locales/uk.json';
import en from './locales/en.json';
import pl from './locales/pl.json';
import cs from './locales/cs.json';
import es from './locales/es.json';
import ru from './locales/ru.json';
import be from './locales/be.json';

import hintsUk from './locales/hints/uk.json';
import hintsEn from './locales/hints/en.json';
import hintsPl from './locales/hints/pl.json';
import hintsCs from './locales/hints/cs.json';
import hintsEs from './locales/hints/es.json';
import hintsRu from './locales/hints/ru.json';
import hintsBe from './locales/hints/be.json';

// Дедуп у пам'яті сесії - один і той самий відсутній ключ (lng:ns:key) не шле
// повторний запит на кожен рендер, лише раз за життя вкладки.
const reportedMissingKeys = new Set<string>();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      uk: { translation: uk, hints: hintsUk },
      en: { translation: en, hints: hintsEn },
      pl: { translation: pl, hints: hintsPl },
      cs: { translation: cs, hints: hintsCs },
      es: { translation: es, hints: hintsEs },
      ru: { translation: ru, hints: hintsRu },
      // No translations yet: every key falls back to `fallbackLng`.
      be: { translation: be, hints: hintsBe },
    },
    lng: localStorage.getItem('language') || 'uk',
    fallbackLng: [ 'uk','en'],
    interpolation: {
      escapeValue: false,
    },
    // Відсутній ключ перекладу інтерфейсу - повідомляємо бекенд (лог, без БД),
    // щоб розробник бачив прогалини, а не лише порожній/англійський текст на екрані.
    saveMissing: true,
    missingKeyHandler: (lngs, ns, key) => {
      const lng = Array.isArray(lngs) ? lngs[0] : lngs;
      const dedupeKey = `${lng}:${ns}:${key}`;
      if (reportedMissingKeys.has(dedupeKey)) return;
      reportedMissingKeys.add(dedupeKey);
      import('../services/api').then(({ default: api }) => {
        api.post('/i18n-gaps/report', { key, ns, language: lng }).catch(() => {});
      });
    },
  });

export default i18n;
